export default [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '课程名称',
    field: 'programName',
  },
  {
    headerName: '课程编码',
    field: 'scoId',
  },
  {
    headerName: '课程分类',
    field: 'programCategoryName',
  },
  {
    headerName: '组织名称',
    field: 'orgName',
  },
  {
    headerName: '组织编码',
    field: 'orgCode',
  },
  {
    headerName: '组织类型',
    field: 'nodeCategoryName',
  },
  {
    headerName: '应学习人数',
    field: 'shoudCount',
  },
  {
    headerName: '已学习人数',
    field: 'factCount',
  },
  {
    headerName: '课程学习率',
    field: 'rate',
  },
  {
    headerName: '已通过人数',
    field: 'passCount',
  },
  {
    headerName: '通过率',
    field: 'passRate',
  }
]